<template>
    <div class="pa-5" v-if="activeNotification">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeNotification.id ? activeNotification.id : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "general-view",
    data() {
        return {};
    },
    computed: {
        ...mapState("NotificationCenterStore", ["activeNotification"])
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
